import { Loader } from '@/components/ui/Loader';

const FullPageSpinner = () => {
  return <Loader size="xl" variant="wine" fullPage />
}

export default FullPageSpinner